<div class="body" #body>

    <ng-container *ngIf="expandedView; else smallView">

        <div class="extended-content">
            <div class="headline">
                Unbekanntes Widget
            </div>
            <div class="text">
                Dieses Widget stammt aus einer früheren Version des AMS und kann derzeitig nicht verwendet werden. Sie
                können das Widget jetzt löschen oder durch ein Neues ersetzen. ({{data.widget.widgetid}})
            </div>
            <div class="control">
                <button class="button" mat-raised-button color="primary" (click)="deleteWidget()">
                    Löschen
                </button>
                <button class="button" mat-raised-button color="primary" (click)="changeWidgetType()">
                    Ersetzen
                </button>
            </div>
        </div>

    </ng-container>

    <ng-template #smallView>

        <div class="small-content">
            <div class="spacer"></div>
            <button mat-icon-button aria-label="Optionen für unbekannten Widgettyp">
                <mat-icon>more_horiz</mat-icon>
            </button>
            <div class="spacer"></div>
        </div>

    </ng-template>

</div>